// Application configuration constants
export const CONFIG = {
  // Cache settings
  CACHE_DURATION: 15 * 60 * 1000, // 15 minutes
  CACHE_KEY: 'csb_weather_data',
  FLAG_CACHE_KEY: 'csb_beach_flag',
  
  // Location settings - Barrier Dunes at Cape San Blas
  CAPE_SAN_BLAS_COORDS: {
    lat: 29.6705,  // Barrier Dunes specific location
    lon: -85.3548  // Northern Cape San Blas near State Park
  },
  
  // Barrier Dunes is at the northern end of Cape San Blas
  BARRIER_DUNES_COORDS: {
    lat: 29.6705,
    lon: -85.3548
  },
  
  // NOAA settings
  NOAA_STATION: '8728942', // Cape San Blas station
  
  // Time settings
  TIMEZONE: 'America/New_York',
  
  // API timeouts
  API_TIMEOUT: 10000, // 10 seconds
  WEATHER_API_TIMEOUT: 15000, // 15 seconds
  NOAA_API_TIMEOUT: 8000, // 8 seconds
  
  // Update intervals
  FLAG_CHECK_INTERVAL: 5 * 60 * 1000, // 5 minutes
  COUNTDOWN_UPDATE_INTERVAL: 60000, // 1 minute
  
  // Beach hours for flag checking
  BEACH_HOURS: {
    start: 9,
    end: 18
  },
  
  // Flag check frequencies
  FLAG_CHECK_FREQUENCY: {
    beachHours: 60 * 60 * 1000, // 1 hour
    offHours: 3 * 60 * 60 * 1000 // 3 hours
  }
};

// Date format options
export const DATE_FORMAT_OPTIONS = {
  timeZone: 'America/New_York',
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  hour12: true
};